import {
  loyaltyService,
  contentService
} from '@/infrastructure/Factory'
import { ManageMembersDirectory } from '@/infrastructure/Configuration'

export default {
  async getMembers({ commit, dispatch }, { corporateId, name, page, limit }) {
    commit('fetchingMembers')

    try {
      const { members, totalMembers } = await loyaltyService.getManageMembers({ corporateId, name, page, limit })
      commit('setMembers', { members, totalMembers })
    } catch (e) {
      dispatch('handleMembersError', e)
    }
    commit('fetchedMembers')
  },

  async deactivateMember({ state, commit, dispatch }, { corporateId, loyaltyNumber, modalId, successModalId }) {
    commit('deactivatingMember')

    try {
      await loyaltyService.deactivateMember(corporateId, loyaltyNumber)
      global.$(successModalId).modal('show')
      commit('resetMembers')
      dispatch('getMembers', { corporateId, page: state.members.page, name: state.filters.name, limit: ManageMembersDirectory.FIRST_LIMIT })
    } catch (e) {
      dispatch('handleMembersError', e)
    } finally {
      commit('deactivatedMember')
      global.$(modalId).modal('hide')
    }
  },

  setFilterByName({ commit }, name) {
    commit('setFilterByName', name)
    commit('resetMembers')
  },

  setCurrentFilteredPage({ commit }, page) {
    commit('setCurrentFilteredPage', page)
  },

  setFilterByStatus({ commit }, status) {
    commit('setFilterByStatus', status)
  },

  clearFilters({ commit }) {
    commit('clearFilters')
  },

  async generateLinks({ commit, dispatch }, { corporateId, emails }) {
    commit('generatingLinks')

    try {
      const corporateInvite = await contentService.getCorporateInvite()
      commit('setCorporateInvite', corporateInvite)

      const { links } = await loyaltyService.generateEnrollentLinks(corporateId, emails)
      commit('setEnrollmentLinks', links)
    } catch (e) {
      dispatch('handleMembersError', e)
    } finally {
      commit('generatedLinks')
    }
  },

  resetLinks({ commit }) {
    commit('resetLinks')
  },

  handleMembersError({ _ }, error) {
    global.ModalMsg.show('#modal-error')
  }
}
